import { Grid, Paper } from '@mui/material'
import { CargoDetailsSubForm } from '@planning/pages/Order/V2/organisms/CargoDetailsSubForm'
import { OrderClientDetailsSubForm } from '@planning/pages/Order/V2/organisms/OrderClientDetailsSubForm'
import { CargoDetailsSubFormStore } from '@planning/pages/Order/V2/stores/CargoDetailsSubFormStore'
import { OrderFormStore, OrderFormStoreType } from '@planning/pages/Order/V2/stores/OrderFormStore'
import { observer } from 'mobx-react-lite'

interface OrderCargoInformationCardProps {
  formStore: OrderFormStore
  cargoDetailsFormStore: CargoDetailsSubFormStore
  initialValues?: Partial<OrderFormStoreType>
  isFromRestowPage?: boolean
}

export const OrderCargoInformationCard = observer(
  ({ cargoDetailsFormStore, formStore, isFromRestowPage }: OrderCargoInformationCardProps) => {
    return (
      <Paper variant='outlined' sx={{ p: '1rem' }}>
        <Grid container direction={'column'}>
          <Grid
            size={{
              sm: 12,
            }}
          >
            <Grid container spacing={2}>
              <Grid
                size={{
                  sm: 12,
                }}
              >
                <OrderClientDetailsSubForm formStore={formStore} />
              </Grid>
              <Grid
                size={{
                  sm: 12,
                }}
              >
                <CargoDetailsSubForm
                  store={cargoDetailsFormStore}
                  isFromRestowPage={isFromRestowPage}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    )
  },
)
